import { ClientEvents } from 'common/events/ClientEvents';
import React from 'react';
import { MealPlanDisplayShefFragment, MealPlanFormat } from 'src/gqlReactTypings.generated.d';
import MealPlanShefCardCarousel from 'src/pages/consumer/meal-plans/components/MealPlanShefCardCarousel';
import { MealPlanShefCount } from 'src/pages/consumer/meal-plans/components/MealPlanShefCount';
import { MealPlanEntryPoints } from 'src/pages/consumer/meal-plans/consts';
import { useMealPlanSurfacingLogic } from 'src/pages/consumer/meal-plans/hooks/useMealPlanSurfacingLogic';
import { useShefProfileNav } from 'src/pages/consumer/meal-plans/meal-plan-intake/your-shefs/hooks/useShefProfileNav';
import { useHistory } from 'src/shared/hooks/useHistory';
import { useTracker } from 'src/shared/hooks/useTracker';
import { getFullRelativeUrl } from 'src/shared/utils/RouteUtilities';
import { Container } from 'web-common/src/shared/design-system/components/Container';
import { CTAFooter, StickyFooterContainer } from 'web-common/src/shared/design-system/components/StickyFooter';

interface NonSubscriberPageContentProps {
  shefs: MealPlanDisplayShefFragment[];
}

const analyticsLocation = 'marketplace-wss-tab';

export const NonSubscriberPageContent: React.FC<NonSubscriberPageContentProps> = ({ shefs }) => {
  const history = useHistory();
  const tracker = useTracker();
  const { navigateToShefMenu } = useShefProfileNav({ analyticsLocation });
  const { isInFlexibleSidesRegion, navigateToMealPlanPreferences } = useMealPlanSurfacingLogic();

  const navigateToMealPlanFirstStep = () => {
    tracker.track(ClientEvents.WSS_GET_STARTED_CLICK, { location: analyticsLocation });
    return navigateToMealPlanPreferences({
      step: 'household',
      entryPoint: MealPlanEntryPoints.ExploreNonSubscriberTab,
      format: isInFlexibleSidesRegion ? MealPlanFormat.FlexibleSides : MealPlanFormat.MainsPlusSides,
      from: getFullRelativeUrl(history.location),
    });
  };

  return (
    <div className='mb-10 flex min-h-[50svh] flex-col items-center justify-center gap-6 py-6'>
      <MealPlanShefCount />
      {shefs.length > 0 && (
        <Container noPadding>
          <MealPlanShefCardCarousel addLeftMargin shefs={shefs} onShefClick={navigateToShefMenu} />
        </Container>
      )}
      <StickyFooterContainer>
        <CTAFooter
          primaryCTACopy='Get started'
          primaryIconName='arrowRight'
          primaryCTAOnClick={navigateToMealPlanFirstStep}
        />
      </StickyFooterContainer>
    </div>
  );
};
